import { AssetsUserDetailsService } from './assets-user-details.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ASSETS_USER_DETAILS_TYPE, AssetsUserDetails } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class AssetsUserDetailsResolverBase implements Resolve<AssetsUserDetails> {

  constructor(protected service: AssetsUserDetailsService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AssetsUserDetails> {
    const key: string = ASSETS_USER_DETAILS_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



